import {
  CreateButton,
  Datagrid,
  DateField,
  ExportButton,
  FilterButton,
  List,
  SelectInput,
  TextField,
  TextInput,
  TopToolbar,
} from 'react-admin';

const userFilters = [
  <TextInput key="search" source="search" label="Search" alwaysOn />,
  <SelectInput
    key="role"
    source="role"
    choices={[
      { id: 'super_admin', name: 'Super Admin' },
      { id: 'admin', name: 'Admin' },
      { id: 'editor', name: 'Editor' },
      { id: 'analyst', name: 'Analyst' },
      { id: 'support', name: 'Support' },
      { id: 'business_owner', name: 'Business Owner' },
    ]}
  />,
  <SelectInput
    key="status"
    source="status"
    choices={[
      { id: 'active', name: 'Active' },
      { id: 'inactive', name: 'Inactive' },
      { id: 'suspended', name: 'Suspended' },
    ]}
  />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export function UserList() {
  return (
    <List filters={userFilters} actions={<ListActions />} perPage={25}>
      <Datagrid rowClick="edit">
        <TextField source="full_name" label="Name" />
        <TextField source="email" />
        <TextField source="role" label="Role" />
        <TextField source="status" />
        <DateField source="last_login_at" label="Last login" showTime />
        <DateField source="created_at" label="Created" showTime />
      </Datagrid>
    </List>
  );
}
